'use client';

import { datadogLogs } from '@datadog/browser-logs';
import Script from 'next/script';
import React from 'react';

import { isStageDev } from '../../utils/common';
import { NAVER_ACCOUNT_ID } from '../../utils/common/naver-script';
import { KAKAO_JAVASCRIPT_KEY } from '../../utils/common/next-migration';

/**
 * @link https://nextjs.org/docs/app/building-your-application/optimizing/scripts#strategy
 *
 * [Script의 strategy 속성]
 * - beforeInteractive: 페이지가 상호작용되기 전에 로드 됩니다.
 * - (DEFALUT) afterInteractive : 페이지가 상호작용이 가능해진 직후에 즉시 로드 되며, strategy 속성의 기본 값입니다.
 * - lazyOnload: idle time 동안에 로드 됩니다.
 * - worker: (experimental) web worker에 로드 됩니다.
 */
const LayoutHeadExternalSDKs = () => {
  return (
    <>
      {/* 헥토 파이낸셜 */}
      {isStageDev ? (
        // 개발 환경 (테스트베드)
        <Script src="https://tbezauth.settlebank.co.kr/js/SettlePay.js" />
      ) : (
        // 상용 환경
        <Script src="https://ezauth.settlebank.co.kr/js/SettlePay.js" />
      )}

      {/* Global Site Tag (gtag.js) - Google Analytics */}
      <Script src="https://www.googletagmanager.com/gtag/js?id=UA-205737198-1" />
      <Script>
        {`window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'UA-205737198-1'); // Universal Analytics property.
          gtag('config', 'G-L3N509VH30'); // Google Analytics 4 property.`}
      </Script>

      {/* kakao SDK v2 */}
      <Script
        src="https://t1.kakaocdn.net/kakao_js_sdk/2.8.0/kakao.min.js"
        integrity="sha384-Lvrr4dmJLLhBimcAC4GfpNV3oEGKgfd26Mp7KkvDz8PxGrhUhUT3zoax7EirW8fu"
        crossOrigin="anonymous"
        onLoad={() => {
          if (typeof window === 'undefined') return;
          if (!KAKAO_JAVASCRIPT_KEY) {
            datadogLogs.logger.error(
              '[Kakao SDK] KAKAO_JAVASCRIPT_KEY 환경변수 누락',
            );
            return;
          }
          if (window.Kakao?.isInitialized?.()) return;
          window.Kakao?.init(KAKAO_JAVASCRIPT_KEY);
        }}
        onError={(e) => {
          datadogLogs.logger.error('[Kakao SDK] 스크립트 로드 실패', {
            src: 'https://t1.kakaocdn.net/kakao_js_sdk/2.8.0/kakao.min.js',
            error: e,
          });
        }}
      />

      {/* naver pay */}
      <Script src="https://nsp.pay.naver.com/sdk/js/naverpay.min.js" />

      {/* iamport */}
      <Script src="https://code.jquery.com/jquery-1.12.4.min.js" />
      <Script src="https://cdn.iamport.kr/js/iamport.payment-1.2.0.js" />

      {/* kakao pixel */}
      <Script src="//t1.daumcdn.net/kas/static/kp.js" />

      {/**
       * naver band
       *
       * 공통 적용 스크립트, 모든 페이지에 노출되도록 설치. 단 전환페이지 설정값보다 항상 하단에 위치해야함
       */}
      <Script type="text/javascript" src="//wcs.naver.net/wcslog.js" />
      <Script type="text/javascript">
        {`
          if (!wcs_add) var wcs_add = {};
          wcs_add['wa'] = '${NAVER_ACCOUNT_ID}';
          if (!_nasa) var _nasa = {};
          if (window.wcs) {
            wcs.inflow('uglyus.co.kr');
            wcs_do(_nasa);
          }
        `}
      </Script>
    </>
  );
};

export default LayoutHeadExternalSDKs;
